import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-wether-visibility',
    template: `
        <ng-template #template>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20" height="20" [ngClass]="class">
          <path d="M18.90625 12.40625C8.90625 15.105469 1.585938 23.507813 1.1875 23.90625C0.886719 24.304688 0.886719 24.789063 1.1875 25.1875C1.6875 25.789063 12 37.59375 25 37.59375C38 37.59375 48.3125 25.8125 48.8125 25.3125C49.113281 24.914063 49.113281 24.304688 48.8125 23.90625C48.414063 23.507813 41.09375 15.105469 31.09375 12.40625C34.09375 14.40625 36 17.695313 36 21.59375C36 27.695313 31.101563 32.59375 25 32.59375C18.898438 32.59375 14 27.695313 14 21.59375C14 17.792969 16.007813 14.40625 18.90625 12.40625 Z M 25 16.59375C22.25 16.59375 20 18.84375 20 21.59375C20 24.34375 22.25 26.59375 25 26.59375C27.75 26.59375 30 24.34375 30 21.59375C30 18.84375 27.75 16.59375 25 16.59375 Z M 25 18.59375C26.667969 18.59375 28 19.925781 28 21.59375C28 23.261719 26.667969 24.59375 25 24.59375C23.332031 24.59375 22 23.261719 22 21.59375C22 19.925781 23.332031 18.59375 25 18.59375Z" fill="currentColor" />
        </svg>
        </ng-template>
    `,
})
export class IconWetherVisibilityComponent {
    @Input() fill: boolean = false;
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
